import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store';
import VCalendar from 'v-calendar';

Vue.config.productionTip = false;

// Register components before new Vue, not afer
Vue.use(VCalendar);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
